export class TakeNativeSnapshotRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "retentionDays",
            "baseName": "retentionDays",
            "type": "number",
            "format": ""
        },
        {
            "name": "targetRegion",
            "baseName": "targetRegion",
            "type": "string",
            "format": ""
        },
        {
            "name": "vaultProtectionMode",
            "baseName": "vaultProtectionMode",
            "type": "VaultProtectionMode",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return TakeNativeSnapshotRequest.attributeTypeMap;
    }
    constructor() {
    }
}
